import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreVersions: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.more-button.more-versions',
		defaultMessage: 'More actions for {issueKey}',
		description:
			'Button label of a meatball menu, indicating user is will get more options if it is clicked',
	},
});
